import * as Material from "@mui/material";
import React from "react";

export function Form_Button_Dropdown(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;
    return (<>
        <div className="btn-group btn-w-100" style={{height: '56px'}}>
            <Material.Button color='secondary' variant='contained' className="btn">Action</Material.Button>
            <Material.Button color='secondary' variant='contained'
                             className="btn dropdown-toggle dropdown-toggle-split"
                             data-bs-toggle="dropdown" aria-expanded="false">
                <span className="visually-hidden">Toggle Dropdown</span>
            </Material.Button>
            <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#">Action</a></li>
                <li><a className="dropdown-item" href="#">Another action</a></li>
                <li><a className="dropdown-item" href="#">Something else here</a>
                </li>
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li><a className="dropdown-item" href="#">Separated link</a></li>
            </ul>
        </div>
    </>);
}